import { useConfig } from '@common/config';
import type configJson from '../../public/config.json';

/**
 * Permet d'avoir le typage de la config
 */
export const useAppConfig = useConfig<typeof configJson>;